var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTaffiLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 21,
    viewBox: "0 0 66 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3411_9333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9364 0.0703125H0.395508V2.27433C2.83696 1.0536 5.07049 0.27958 7.54279 0.27958H7.95999V20.9769H10.3746V0.27958H10.7918C13.2641 0.27958 15.4976 1.0536 17.9391 2.27433L17.9364 0.0703125Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6875 20.9769H51.0699V9.7932C52.463 9.60805 53.8675 9.52242 55.2727 9.53698C56.682 9.52328 58.0905 9.6098 59.4876 9.79588V8.80991C58.0905 8.996 56.682 9.08251 55.2727 9.06881C53.8675 9.08203 52.4631 8.99641 51.0699 8.81259V0.27958H53.9299C56.4009 0.27958 58.6344 1.0536 61.0772 2.27433V0.0703125H48.6875V20.9769Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6123 20.9769H36.9947V9.7932C38.3873 9.60805 39.7914 9.52242 41.1962 9.53698C42.6059 9.52332 44.0149 9.60984 45.4124 9.79588V8.80991C44.0149 8.99595 42.6059 9.08247 41.1962 9.06881C39.7914 9.08203 38.3875 8.99641 36.9947 8.81259V0.27958H39.8534C42.3257 0.27958 44.5592 1.0536 47.0007 2.27433V0.0703125H34.6123V20.9769Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1422 0.0703125H62.7598V20.9769H65.1422V0.0703125Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.747 0.0703125L23.5518 2.16835L18.5415 13.6673L15.4199 20.9769H16.5682L19.6804 13.6673L19.7206 13.5748L19.8186 13.5466C21.1095 13.3929 22.4087 13.3181 23.7088 13.3226C24.9725 13.3144 26.2357 13.3803 27.4917 13.5198H27.5266H27.5856C27.6917 13.5327 27.7966 13.5538 27.8995 13.5828L28.53 15.2368L28.9204 16.2617L29.8768 18.7689L30.7125 20.9769H33.1003L25.1281 0.0703125H22.747ZM20.0734 12.7712L24.1193 3.48835L27.5829 12.7444C26.2983 12.8915 25.0058 12.9596 23.7128 12.9483C22.4971 12.9668 21.2815 12.9072 20.0734 12.7699",
    fill: "#1A1A1A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3411_9333"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64.7468,
    height: 20.9066,
    fill: "white",
    transform: "translate(0.395508 0.0703125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaffiLogo);
export default __webpack_public_path__ + "static/media/Taffi_Logo.51656efd3974862e53fa77aa3d526237.svg";
export { ForwardRef as ReactComponent };